import { Util } from "src/app/shared/utils/util";

export class ReadaptacaoResponseDTO {
  public profissional: DadosServidorDTO;
  public readaptacao: DadosReadaptacao;

  constructor(obj: any) {
    if (obj) {
      this.profissional = new DadosServidorDTO(obj.profissional);
      this.readaptacao = new DadosReadaptacao(obj.readaptacao);
    }
  }
}

export class DadosServidorDTO {
  public profissionalId: string;
  public profissionalMatriculaId: string;
  public nome: string;
  public matricula: string;
  public cpf: string;
  public situacaoFuncional: string;
  public utb: string;

  constructor(obj: any) {
    if (obj) {
      this.profissionalId = obj.profissionalId;
      this.profissionalMatriculaId = obj.profissionalMatriculaId;
      this.nome = obj.nome;
      this.matricula = obj.matricula;
      this.cpf = Util.formatarCPF(obj.cpf);
      this.situacaoFuncional = obj.situacaoFuncional;
      this.utb = obj.utb;
    }
  }
}

export class DadosReadaptacao {
  public id?: string;
  public tipo: string;
  public dataInicio: string;
  public dataFim: string;
  public tempoTotal: number;
  public dataDiarioOficial: string;
  public numeroResenha: string;
  public motivo: string;
  public responsavel: string;
  public dataUltimaAtualizacao: string;
  public status: string;
  public confirmouInformacoes: boolean;
  public periodoReadaptacao: string;

  constructor(obj: any) {
    if (obj) {
      this.id = obj.id;
      this.tipo = obj.tipo;
      this.dataInicio = obj.dataInicio;
      this.dataFim = obj.dataFim;
      this.tempoTotal = obj.tempoTotal;
      this.dataDiarioOficial = obj.dataDiarioOficial;
      this.numeroResenha = obj.numeroResenha;
      this.motivo = obj.motivo;
      this.responsavel = obj.responsavel;
      this.status = obj.status;
      this.confirmouInformacoes = obj.confirmouInformacoes;
      this.periodoReadaptacao = Util.getDataReadaptacaoFormatada(obj);
      this.dataUltimaAtualizacao = obj.dataUltimaAtualizacao;
    }
  }
}
